import { render } from "./BlogContent.vue?vue&type=template&id=9bb659d8&scoped=true&ts=true"
import script from "./BlogContent.vue?vue&type=script&lang=ts"
export * from "./BlogContent.vue?vue&type=script&lang=ts"

import "./BlogContent.vue?vue&type=style&index=0&id=9bb659d8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bb659d8"]])

export default __exports__